import { FieldErrors } from 'react-hook-form'
import { AddonSettings } from '@ancon/wildcat-types'

import { ProductConfigureAccordionId } from '../constants'
import { ConfigureProductFormState } from '../types'

import getAddonGroupDisplayOrder from './getAddonGroupDisplayOrder'

type InvalidProductSection = {
  sectionId: string
  /** The section's name, `null` for the variants section */
  name: string | null
}

type AddonGroup = {
  addOnGroupName: string
  addOnSettings: AddonSettings
}

/**
 * The first section of the product modal that keeps the product from being
 * added, in the order the sections are shown
 */
export default function getFirstInvalidProductSection(
  errors: FieldErrors<ConfigureProductFormState>,
  addonGroups: AddonGroup[] | null | undefined,
): InvalidProductSection | null {
  if (errors.selectedVariantId) {
    return { sectionId: ProductConfigureAccordionId.Variants, name: null }
  }

  const addonErrors = errors.selectedAddons

  if (!addonErrors || !addonGroups) {
    return null
  }

  const index = getAddonGroupDisplayOrder(addonGroups).find(
    i => !!addonErrors[i],
  )

  if (index === undefined) {
    return null
  }

  const { addOnSettings, addOnGroupName } = addonGroups[index]

  return {
    sectionId: ProductConfigureAccordionId.AddonGroup(index),
    name: addOnSettings.customerFacingName || addOnGroupName,
  }
}
